
const nameList = [
    {
        entityField: "shelfCode",
        showField: "货架号",
        fieldWeight: 100,
        fieldType: "string",

    },


    {
        entityField: "remark",
        showField: "备注",
        fieldWeight: 130,
        fieldType: "string",

    },


]


const storeList = [

    {
        entityField: "bgmCode",
        showField: "商品编码",
        fieldWeight: 70,
        fieldType: "string",

    },
    {
        entityField: "bgmName",
        showField: "通用名称",
        fieldWeight: 70,
        fieldType: "string",

    },
    {
        entityField: "spec",
        showField: "规格",
        fieldWeight: 100,
        fieldType: "string",

    },
    {
        entityField: "num",
        showField: "总库存",
        fieldWeight: 100,
        fieldType: "string",

    },

    {
        entityField: "manufacturer",
        showField: "生产商",
        fieldWeight: 100,
        fieldType: "string",

    },

    {
        entityField: "placeorigin",
        showField: "产地",
        fieldWeight: 100,
        fieldType: "string",

    },

]
const searchList = [
    {
        showField: "货架号",
        entityField: "shelfCode",
        isShow: 1,
        fieldType: "string",
        searchId: null,
        formatterContent: null,
        isRift: null,
        riftField: null,
        setField: null,
        fieldWeight: 120,
    },

]
const searchList2 = [
 
    {
        showField: "通用名称",
        entityField: "bgmName",
        isShow: 1,
        fieldType: "string",
        searchId: null,
        formatterContent: null,
        isRift: null,
        riftField: null,
        setField: null,
        fieldWeight: 120,
    },

]





export { nameList, storeList, searchList, searchList2 }